import { Grid } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { changeStatus, changeType, displayLabel, riskLevel, scheduleStatus } from "../../constants/labels";
import { OssDataGridFrame } from "../common/OssDataGridFrame";
import { OssSectionPanel } from "../common/OssPanel";

export const OssReportTables = ({ report = {}, loading }) => (
  <Grid container spacing={1.5}>
    <Grid item xs={12} lg={7}>
      <OssSectionPanel title="예외 주문">
        <OssDataGridFrame height={420}>
          <DataGrid
            disableRowSelectionOnClick
            loading={loading}
            rows={report.exceptions || []}
            getRowId={(row) => `${row.order_no}-${row.item_name_snapshot}-${row.requested_due_date}`}
            columns={[
              { field: "order_no", headerName: "주문번호", flex: 0.9 },
              { field: "customer_name", headerName: "거래처", flex: 0.8 },
              { field: "item_name_snapshot", headerName: "품목", flex: 1 },
              { field: "requested_due_date", headerName: "납기", flex: 0.7 },
              { field: "schedule_status", headerName: "상태", flex: 0.8, renderCell: ({ value }) => displayLabel(scheduleStatus, value) },
              { field: "risk_level", headerName: "위험", flex: 0.7, renderCell: ({ value }) => displayLabel(riskLevel, value) },
            ]}
            hideFooter
          />
        </OssDataGridFrame>
      </OssSectionPanel>
    </Grid>
    <Grid item xs={12} lg={5}>
      <OssSectionPanel title="변경 이력">
        <OssDataGridFrame height={420}>
          <DataGrid
            disableRowSelectionOnClick
            loading={loading}
            rows={report.changes || []}
            getRowId={(row) => row.change_request_id}
            columns={[
              { field: "order_no", headerName: "주문번호", flex: 0.9 },
              { field: "change_type", headerName: "유형", flex: 0.7, renderCell: ({ value }) => displayLabel(changeType, value) },
              { field: "request_status", headerName: "상태", flex: 0.8, renderCell: ({ value }) => displayLabel(changeStatus, value) },
              { field: "requested_at", headerName: "요청일시", flex: 1 },
            ]}
            hideFooter
          />
        </OssDataGridFrame>
      </OssSectionPanel>
    </Grid>
  </Grid>
);
